import angular from "angular";

angular
    .module('app')
    .component('groupCreateForm', {
        template: require('./group-create-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment) {

    let $ctrl = this;

    $ctrl.course = null;
    $ctrl.startDate = null;
    $ctrl.cost = 0;
    $ctrl.discountValue = 0;
    $ctrl.onlinePayment = true;
    $ctrl.offlinePayment = false;
    $ctrl.paymentInfo = null;

    $ctrl.$onInit = function () {
        $ctrl.courses = $ctrl.resolve.courses;
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let startDate = moment($ctrl.startDate).format('YYYY-MM-DD');

        let params = {
            course_id: $ctrl.course.id,
            start_date: startDate,
            cost: $ctrl.cost,
            discount_value: $ctrl.discountValue,
            online_payment: $ctrl.onlinePayment,
            offline_payment: $ctrl.offlinePayment,
            payment_info: $ctrl.paymentInfo
        };

        $http
            .post('/admin/groups', params)
            .then(
                function (response) {

                    Notifier.success('Группа успешно создана', 2);

                    $ctrl.loading = false;

                    params.course_title = $ctrl.course.title;
                    params.id = response.data.id;
                    params.status = response.data.status;

                    $ctrl.close({$value: params});
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    }

}
